export interface MenuItemOrder {
  id: number;
  order: number;
}

export const menuItemOrderToUpsertRequest = (menuItemOrder: MenuItemOrder) => ({
  id: menuItemOrder.id,
  order: menuItemOrder.order,
});
